import { Check, X } from "lucide-react";
import { useI18n } from "../../../i18n";
import { STAGE_OF } from "../../../components/common/StatusBadge";

const FLOW = ["sent", "received", "ready", "delivered"];

export const StatusTimeline = ({ status }) => {
  const { t } = useI18n();
  if (status === "cancelled") {
    return <p className="flex items-center gap-2 text-sm font-semibold text-rose-700" data-testid="timeline-cancelled"><X className="h-4 w-4" /> {t("status.cancelled")}</p>;
  }
  const steps = status === "pending_approval" ? ["pending_approval", ...FLOW] : FLOW;
  const current = status === "pending_approval" ? 0 : steps.indexOf(STAGE_OF[status]);
  return (
    <ol className="space-y-0" data-testid="status-timeline">
      {steps.map((s, i) => {
        const done = i < current; const now = i === current;
        return (
          <li key={s} className="flex gap-3" data-testid={`timeline-step-${s}`}>
            <div className="flex flex-col items-center">
              <span className={`grid h-7 w-7 place-items-center rounded-full text-xs font-bold ${done || (now && s === "delivered") ? "bg-brand text-white" : now ? "bg-navy text-white ring-4 ring-navy/15" : "bg-slate-200 text-slate-500"}`}>
                {done || (now && s === "delivered") ? <Check className="h-4 w-4" /> : i + 1}
              </span>
              {i < steps.length - 1 && <span className={`h-6 w-0.5 ${done ? "bg-brand" : "bg-slate-200"}`} />}
            </div>
            <span className={`pt-1 text-sm ${now ? "font-semibold text-navy" : done ? "text-slate-700" : "text-slate-400"}`}>{t(s === "pending_approval" ? "status.pending_approval" : `cstage.${s}`)}</span>
          </li>
        );
      })}
    </ol>
  );
};
